import React from 'react';
import { cn } from '@/lib/utils/cn';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export function Input({ className, label, error, helperText, id, ...props }: InputProps) {
  const inputId = id ?? props.name ?? props.placeholder ?? 'input';

  return (
    <div className="space-y-1.5">
      {label && (
        <label htmlFor={inputId} className="block text-2 font-medium tracking-wide text-fg-secondary">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={cn(
          'flex h-10 w-full rounded-3 border border-border bg-surface px-3 py-2 text-3 text-fg placeholder:text-fg-tertiary/60',
          'focus-visible:outline-none focus-visible:border-primary-400/40 focus-visible:ring-sm',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'transition-all duration-3 ease',
          error && "border-accent-red focus-visible:ring-destructive focus-visible:border-accent-red/40",
          className
        )}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined}
        {...props}
      />
      {error && (
        <p id={`${inputId}-error`} className="text-2 text-accent-red" role="alert">
          {error}
        </p>
      )}
      {helperText && !error && (
        <p id={`${inputId}-helper`} className="text-2 text-fg-tertiary">
          {helperText}
        </p>
      )}
    </div>
  );
}
Input.displayName = "Input";
